import * as _ from "lodash";
import * as actions from "./actions";

const state = {
  applications: [],
  provinces: []
};
const mutations = {
  setApplications(state, applications) {
    state.applications = applications;
  },
  setProvinces(state, provices) {
    state.provinces = provices;
  }
};

const getters = {
  getApplications(state) {
    return state.applications;
  },
  getProvinces(state) {
    return state.provinces;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
